import { render, staticRenderFns } from "./updateCustomRoutes.vue?vue&type=template&id=872e973e"
import script from "./updateCustomRoutes.vue?vue&type=script&lang=js"
export * from "./updateCustomRoutes.vue?vue&type=script&lang=js"
import style0 from "./updateCustomRoutes.vue?vue&type=style&index=0&id=872e973e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports